import { FC, ReactNode } from 'react'
import clsx from 'clsx'

import styles from './Sidebar.module.scss'

type SidebarProps = {
  children: ReactNode
  modificator?: string
}

const Sidebar: FC<SidebarProps> = ({ children, modificator }) => {
  return <div className={clsx(styles.sidebar, modificator)}>{children}</div>
}

export default Sidebar
